<template>
  <div class="rounded-lg bg-light-bg-danger p-3 text-base font-normal leading-6 text-white">
    {{ message }}
  </div>
</template>

<script setup lang="ts">
interface Props {
  message: string;
}

defineProps<Props>();
</script>
